export var superscript = {
    parseDOM: [{ tag: 'sup' }, { style: 'vertical-align=super' }],
    toDOM: function () { return ['sup', 0]; },
    excludes: 'subscript',
};
